export const CustomTypes = {
	UPMCESOSEARCH: 'upmcesosearch',
};
